export default __webpack_public_path__ + "static/media/issue.75d0095e.svg";